import { render } from "./ShopList.vue?vue&type=template&id=02e0a36c"
import script from "./ShopList.vue?vue&type=script&lang=js"
export * from "./ShopList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__